import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';
import { get } from 'aws-amplify/api';
import Sidebar from "../Components/AppComponents/Sidebar";
import { PricingContainer, Heading, CardRow, Card, CardTitle, CardTitleBorder, CardPrice, CardPriceSubHeading, CardBulletList, BulletListItem, BulletListCheckMark, CardButton, ArrowIcon } from '../Components/HomePageComponents/Pricing/PricingComponents';
import 'bootstrap/dist/css/bootstrap.min.css';

function CheckoutPage() {
    const navigate = useNavigate();

    useEffect(() => {
        const checkAuthStatus = async () => {
          try {
            const user = await getCurrentUser();
            if (user) {
              try {
                const restOperation = get({ apiName: 'userapi', path: '/checkSubscription' });
                const { body } = await restOperation.response;
                const str = await body.text();
                if (str === "false") {
                  navigate('/checkout');
                } else {
                  sessionStorage.setItem("subscriptionStatus", str);
                  navigate('/account')
                }
              } catch (error) {
                console.log('ERROR CODE: CP01');
              }
            } 
          } catch (e) {
            navigate('/login');
            console.log("ERROR CODE: CP02");
          }
        };
    
        checkAuthStatus();
      }, [navigate]);

    const handleSubscribe = async (subscriptionPlan, buttonRef) => {
        try {
            buttonRef.style.cursor = 'wait';
            const restOperation = get({ apiName: 'userapi', path: '/checkout', options: { queryParams: { message: subscriptionPlan } } });
            const { body } = await restOperation.response;
            const urlObj = await body.json();
            window.open(urlObj.url, '_blank');
        } catch (e) {
            console.log("ERROR CODE: B02");
        } finally {
            buttonRef.style.cursor = 'pointer';
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingLeft: '15rem', height: '100vh', backgroundColor: 'var(--background-color)', }}>
            <Sidebar />
            <PricingContainer style={{ textAlign: 'center' }}>
                <Heading>Subscribe to Flagpole</Heading>
                <CardRow>
                    <Card>
                        <CardTitle>Monthly</CardTitle>
                        <CardTitleBorder />
                        <CardPrice>$5</CardPrice>
                        <CardPriceSubHeading>per month</CardPriceSubHeading>
                        <CardBulletList>
                            <BulletListItem><BulletListCheckMark />Instantly create new schedules</BulletListItem>
                            <BulletListItem><BulletListCheckMark />Download schedules as CSV or PDF</BulletListItem>
                            <BulletListItem><BulletListCheckMark />Email Support 7 days a week</BulletListItem>
                        </CardBulletList>
                        <CardButton onClick={(e) => handleSubscribe("Monthly", e.target)}>
                            Click to subscribe <ArrowIcon />
                        </CardButton>
                    </Card>
                    <Card>
                        <CardTitle>Annual</CardTitle>
                        <CardTitleBorder />
                        <CardPrice>$50</CardPrice>
                        <CardPriceSubHeading>per year</CardPriceSubHeading>
                        <CardBulletList>
                            <BulletListItem><BulletListCheckMark />Instantly create new schedules</BulletListItem>
                            <BulletListItem><BulletListCheckMark />Download schedules as CSV or PDF</BulletListItem>
                            <BulletListItem><BulletListCheckMark />Email Support 7 days a week</BulletListItem>
                        </CardBulletList>
                        <CardButton onClick={(e) => handleSubscribe("Yearly", e.target)}>
                            Click to subscribe <ArrowIcon />
                        </CardButton>
                    </Card>
                </CardRow>
            </PricingContainer>
        </div>
    );
};

export default CheckoutPage;
